import { useAuth } from "../useAuth";
import { useQuery } from "@apollo/client";
import { UserInfosDocument } from "../../__generated__/graphql";

export default function useUserInfos() {
  const { isAuthenticated } = useAuth();

  const { data, loading, error, refetch } = useQuery(UserInfosDocument, {
    skip: !isAuthenticated,
  });

  return { data, loading, error, refetch };
}
